import VisualisationsToolboxAbstract from '../VisualisationsToolboxAbstract';

class VideoToolbox extends VisualisationsToolboxAbstract {
  static addParams() {}

  static canProcess(nextProps) {
    return (
      nextProps.layer &&
      (nextProps.layer.layer_participation_associations.length > 0 ||
        nextProps.layer.layer_group_participations_associations.length > 0)
    );
  }

  static getVisualisationComponent() {
    return null;
  }

  static getProcessButtonLabel() {
    return 'Video';
  }

  static getBlockParameters() {
    return {
      windowdStep: 1,
      windowdSize: 2,
      extract: true
    };
  }
}

export default VideoToolbox;


// WEBPACK FOOTER //
// ./src/scenes/analysis/lib/visualisationTypes/VideoToolbox.js